import * as React from 'react';
import { Dialog, DialogActions, Button, DialogTitle, DialogContent, DialogContentText } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface IDeleteWarningDialogProps {
	open: boolean,
	onClose: () => void,
	onAcceptDelete: () => void,
}

export default function DeleteWarningDialog(props: IDeleteWarningDialogProps) {
	const { t } = useTranslation();

	return <Dialog
		className="delete-warning-dialog"
		open={props.open}
		onClose={() => this.handleClose()}
	>
		<DialogTitle>{t("common.message.areYouSureYouWantToDeleteEntry")}</DialogTitle>
		<DialogContent>
			<DialogContentText>
				{t("common.message.areYouSureYouWantToDeleteEntry")}
			</DialogContentText>
		</DialogContent>
		<DialogActions>
			<Button onClick={props.onClose} color="default">
				{t("common.action.cancel")}
			</Button>
			<Button onClick={props.onAcceptDelete} color="primary" variant="contained" autoFocus>
				{t("common.action.ok")}
			</Button>
		</DialogActions>
	</Dialog>
}